
<template>
  <div class="filter-builder">
    <!-- <div class="attribute-row">
      <span class="label">Attribute</span>
      <custom-drop-down
        :defaultStyle="{ dropDownWidth: '10rem', labelHeight: '30px', ddLabelFontSize: '0.85em' }"
        :list="attributeOptions"
        :selected="{ id: selectedAttribute, name: selectedAttribute }"
        @select="({ id }) => { selectedAttribute = id }"
        class="attribute-dropdown"
      />
    </div> -->

    <div class="section">
      <!-- <div class="section-header"> -->
        <!-- <div class="section-title"></div> -->
        <!-- <span class="match-count">{{ matchingRecords }} matching record(s)</span> -->
      <!-- </div> -->

      <div
        class="group-wrapper"
      >
        <condition-group
          :group="[...treeManager.root]"
          :newCondition="createCondition"
          :newSubgroup="createSubgroup"
          :treeManager="treeManager"
          :selectedFeatureId="selectedFeatureId"
          :isEditable="isEditable"
        />
      </div>
    </div>
    <div class="v-center flex-end gap-1">
      <button v-if="!isEditable" class="btn btn-cancel" @click="$emit('cancel')">Back</button>
      <template v-else>
        <button class="btn btn-cancel" @click="$emit('cancel')">Cancel</button>
        <button class="btn" @click="emitSave">Save</button>
      </template>
    </div>
  </div>
</template>

<script>
import ConditionGroup from '@/components/workflows/conditionGroup.vue'
import ConditionTree from './conditionTree'
import config from '@/config'
const initialConditions = [
  {
    id: '1',
    parentId: null,
    field: 'status',
    operator: 'is',
    values: []
  }
]

const getConditionFieldName = (selectedFeatureId) => {
  return selectedFeatureId === config.CORE_FEATURES.BOM || selectedFeatureId === config.CORE_FEATURES.DOCUMENTS
    ? 'state'
    : 'status'
}

const getStatusOptions = (selectedFeatureId) => {
  if (selectedFeatureId === config.CORE_FEATURES.MATERIAL) {
    return Object.keys(config.MATERIAL_STATUS_MAP || {}).map(key => ({
      id: Number(key),
      name: config.MATERIAL_STATUS_MAP[key]
    }))
  }
  if (selectedFeatureId === config.CORE_FEATURES.BOM) {
    return Object.keys(config.BOM_STATE_MAP || {}).map(key => ({
      id: Number(config.BOM_STATE_MAP[key]),
      name: key
    }))
  }
  if (selectedFeatureId === config.CORE_FEATURES.DOCUMENTS) {
    return Object.keys(config.DOC_STATE || {}).map(key => ({
      id: Number(key),
      name: config.DOC_STATE[key]
    }))
  }
  if (selectedFeatureId === config.CORE_FEATURES.FORMS) {
    return Object.keys(config.FORM_STATE || {}).map(key => ({
      id: Number(key),
      name: config.FORM_STATE[key]
    }))
  }
  return []
}

const normalizeConditionValue = (value, options = []) => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  if (typeof value === 'number') {
    return value
  }

  const normalizedValue = String(value).trim()
  if (/^-?\d+$/.test(normalizedValue)) {
    return Number(normalizedValue)
  }

  const matchedOption = options.find(option =>
    String(option.name).toLowerCase() === normalizedValue.toLowerCase() ||
    String(option.id) === normalizedValue
  )

  return matchedOption ? matchedOption.id : normalizedValue
}

const sanitizeTreeData = (list = [], selectedFeatureId = null) => {
  const source = Array.isArray(list) ? list : []
  const statusOptions = getStatusOptions(selectedFeatureId)
  const fieldName = getConditionFieldName(selectedFeatureId)
  // previous multi-level tree support retained for future use:
  // const nodeById = {}
  // source.forEach((item) => {
  //   nodeById[item.id] = item
  // })
  //
  // const rootNodes = source.filter(item => item.parentId === null || !nodeById[item.parentId])
  // const sanitized = []
  //
  // rootNodes.forEach((root) => {
  //   sanitized.push({ ...root, parentId: null })
  //   source
  //     .filter(item => item.parentId === root.id)
  //     .forEach((child) => {
  //       sanitized.push({ ...child, parentId: root.id })
  //     })
  // })
  //
  // return sanitized
  const firstCondition = source.find(item => item && typeof item === 'object') || {}
  const normalizedOperator = ['is', 'contains'].includes(firstCondition.operator) ? firstCondition.operator : 'is'
  const normalizedField = firstCondition.field === 'state' || firstCondition.field === 'status'
    ? fieldName
    : (firstCondition.field || fieldName)
  return [{
    id: firstCondition.id || '1',
    parentId: null,
    field: normalizedField,
    operator: normalizedOperator,
    values: Array.isArray(firstCondition.values)
      ? firstCondition.values
        .map(value => normalizeConditionValue(value, statusOptions))
        .filter(value => value !== null)
      : []
  }]
}

let idCounter = 0
const uid = () => ++idCounter

export default {
  name: 'conditionBuilder',
  components: { ConditionGroup },
  props: {
    initialData: {
      type: Object,
      default: () => null
    },
    selectedFeatureId: {
      type: Number,
      default: null
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    const defaultAttribute = 'My opportunities'
    const initialTreeData = sanitizeTreeData(this.initialData?.treeData || initialConditions, this.selectedFeatureId)
    const initialObject = this.initialData?.object || {}
    return {
      selectedAttribute: this.initialData?.attribute || defaultAttribute,
      matchingRecords: 33,
      validationName: initialObject.name || 'Bom State Check',
      validationDescription: initialObject.description || 'Bom State Check',
      validationType: 'BLOCK_STEP_COMPLETION',
      attributeOptions: [
        { name: 'My opportunities', id: 'My opportunities' },
        { name: 'All opportunities', id: 'All opportunities' },
        { name: 'My accounts', id: 'My accounts' }
      ],

      connectorOptions: [
        { name: 'And', id: 'And' },
        { name: 'Or', id: 'Or' }
      ],
      treeManager: new ConditionTree(initialTreeData)

    }
  },
  methods: {
    createCondition () {
      const fieldName = getConditionFieldName(this.selectedFeatureId)
      return {
        id: uid(),
        field: fieldName,
        operator: 'is',
        values: [],
        valueDropdownOpen: false
      }
    },
    createSubgroup () {
      return {
        id: uid(),
        conditions: [this.createCondition()]
      }
    },
    normalizeOperator (operator) {
      const operatorMap = {
        is: 'EQUALS',
        contains: 'INCLUDES'
      }
      return operatorMap[operator] || operator.toUpperCase().replace(/ /g, '_')
    },
    normalizeConnector (operator) {
      return (operator || 'and').toLowerCase() === 'or' ? 'OR' : 'AND'
    },
    buildCondition (item) {
      const intList = []
      const stringList = []
      ;(item.values || []).forEach((value) => {
        if (value === null || value === undefined || value === '') {
          return
        }
        if (typeof value === 'number') {
          intList.push(value)
          return
        }

        const normalizedValue = String(value).trim()
        if (!normalizedValue) {
          return
        }
        if (/^-?\d+$/.test(normalizedValue)) {
          intList.push(parseInt(normalizedValue, 10))
        } else {
          stringList.push(normalizedValue)
        }
      })
      const condition = {
        left_operand: item.field,
        operator: this.normalizeOperator(item.operator)
      }
      if (intList.length > 0) {
        condition.int_list = intList
      }
      if (stringList.length > 0) {
        condition.string_list = stringList
      }
      return condition
    },
    buildValidationObject () {
      const groups = this.treeManager.root.map((rootNode, index, roots) => {
        // const subGroups = rootNode.children || []
        // const subgroupConnector = this.normalizeConnector(subGroups[0]?.logicalOperator)
        const isLast = index === roots.length - 1
        const conditions = [this.buildCondition(rootNode)]
        // previous support for subgroup conditions retained:
        // const conditions = [this.buildCondition(rootNode), ...subGroups.map(item => this.buildCondition(item))]
        return {
          type: 'AND',
          // type: subgroupConnector,
          sequence: index + 1,
          operator_to_next_group: isLast ? null : this.normalizeConnector(rootNode.logicalOperator),
          validation_conditions: {
            data: conditions
          }
        }
      })
      return {
        name: null,
        description: null,
        type: 'BLOCK_STEP_COMPLETION',
        validation_groups: {
          data: groups
        }
      }
    },
    emitSave () {
      this.$emit('save', {
        attribute: this.selectedAttribute,
        treeData: this.treeManager.getFlat(),
        object: this.buildValidationObject()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$color-primary:          #7c3aed;
$color-primary-focus-bg: #f5f3ff;
$color-border-base:      #e5e7eb;
$color-text-primary:     #111827;
$color-text-secondary:   #374151;
$color-text-muted:       #6b7280;
$font-size-sm:           12px;
$font-size-base:         13px;
$shadow-card:            0 1px 3px rgba(0, 0, 0, 0.08);
$color-bg-surface:       #f9fafb;

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.filter-builder {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: $font-size-base;
  color: $color-text-primary;
  display: flex;
  flex-direction: column;
  max-width: 700px;
}

.attribute-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.label {
  font-size: $font-size-base;
  color: $color-text-muted;
  min-width: 60px;
}

.attribute-dropdown {
  min-width: 180px;
}

.section {
  border: none;
  border-radius: 0;
  overflow: visible;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-bottom: 1px solid $color-border-base;
  background: $color-bg-surface;
  border-radius: 8px 8px 0 0;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  font-size: $font-size-base;
  color: $color-text-secondary;
}

.match-count {
  font-size: $font-size-sm;
  color: $color-text-muted;
}

.group-wrapper {
  padding: 12px 14px 0;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;

  & > * {
    width: 100%;
  }

  &:last-of-type {
    padding-bottom: 12px;
  }
}

.group-connector {
    align-self: baseline;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.connector-line {
  flex: 1;
  height: 1px;
  background: $color-border-base;
}

.connector-dropdown {
  min-width: 70px;
}

.add-actions {
  display: flex;
  gap: 12px;
  padding: 6px 0 4px;
}

.section-add-actions {
  padding: 10px 14px;
  border-top: 1px solid $color-border-base;
}

.add-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: $color-primary;
  font-size: $font-size-sm;
  font-weight: 500;
  padding: 4px 6px;
  border-radius: 4px;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: $color-primary-focus-bg;
  }
}
</style>
